const LIST_DAY_FORMAT = {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
};

// Seven days from the start date rather than a Sunday-start week, so today is at the top.
export default function scheduleListView({ listDayFormat } = {}) {
  return {
    type: 'list',
    duration: { days: 7 },
    listDayFormat: listDayFormat || LIST_DAY_FORMAT,
    listDayAltFormat: false,
  };
}
